var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { reset } from 'redux-form';
import { showModal, MODAL_TYPE_SOLUTION_ADD, } from '../../../../../actions/ModalActions';
import { showNotification } from '../../../../../actions/NotificationActions';
import { initializeProfessionalSolution, apiGetOneProfessionalSolution, apiCreateProfessionalSolution, apiUpdateProfessionalSolution, API_GET_ONE_PROFESSIONAL_SOLUTION, } from '../../../../../actions/ProfessionalSolutionActions';
import { wrapDispatch } from '../../../../../helpers/action';
import { propArrayShape, propBool, propFunc, propShape, propMatch, propHistory, } from '../../../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../../../helpers/fetch';
import { uploadFilePromiseAndGetTemporaryId } from '../../../../../helpers/files';
import { parseParams, initialValuesForFormSolutionAdd, } from '../../../../../helpers/form_solution';
import Layout from '../../../../Layout';
import AuthenticationHoc from '../../../../System/AuthenticationHoc';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
import { ProcessLoader } from '../../../../Ui/Loading';
import FormSolutionCreate from './FormSolutionCreate';
import StepMenu from './StepMenu';
const baseMeta = {
    form: 'FormSolutionCreate',
};
class Add extends Component {
    constructor(props) {
        super(props);
        this.safeSetState = (setState) => {
            if (!this.unmount) {
                this.setState(setState);
            }
        };
        this.previewSolution = () => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, professionalSolution } = this.props;
            try {
                this.safeSetState({ isLoading: true, isPreviewLoading: true });
                const params = yield this.makeParams(1);
                const detail = professionalSolution.detail || {};
                let result;
                if (!detail.id) {
                    result = yield wrapDispatch(dispatch, apiCreateProfessionalSolution(params, baseMeta));
                }
                else {
                    result = yield wrapDispatch(dispatch, apiUpdateProfessionalSolution(detail.id, params, baseMeta));
                }
                const { id } = result.payload;
                window.open(`/solutions/${id}?preview=on`);
            }
            finally {
                this.safeSetState({ isLoading: false, isPreviewLoading: false });
            }
        });
        this.saveSolution = () => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, history, professionalSolution } = this.props;
            try {
                this.safeSetState({ isLoading: true, isSaveLoading: true });
                const params = yield this.makeParams(1);
                const detail = professionalSolution.detail || {};
                if (!detail.id) {
                    yield wrapDispatch(dispatch, apiCreateProfessionalSolution(params, baseMeta));
                }
                else {
                    yield wrapDispatch(dispatch, apiUpdateProfessionalSolution(detail.id, params, baseMeta));
                }
                dispatch(showNotification('保存しました'));
                history.push('/mypage/');
            }
            finally {
                this.safeSetState({ isLoading: false, isSaveLoading: false });
            }
        });
        this.submitSolution = () => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, professionalSolution } = this.props;
            try {
                this.safeSetState({ isLoading: true, isSubmitLoading: true });
                const params = yield this.makeParams(2);
                const detail = professionalSolution.detail || {};
                if (!detail.id) {
                    yield wrapDispatch(dispatch, apiCreateProfessionalSolution(params, baseMeta));
                }
                else {
                    yield wrapDispatch(dispatch, apiUpdateProfessionalSolution(detail.id, params, baseMeta));
                }
                dispatch(showModal(MODAL_TYPE_SOLUTION_ADD));
            }
            finally {
                this.safeSetState({ isLoading: false, isSubmitLoading: false });
            }
        });
        this.makeParams = (status) => __awaiter(this, void 0, void 0, function* () {
            const { dispatch, formFields } = this.props;
            const values = Object.assign({}, formFields.values);
            if (values.pdfFile) {
                const temporaryId = yield uploadFilePromiseAndGetTemporaryId({
                    dispatch,
                    file: values.pdfFile,
                });
                _.set(values, 'pdfFileId', temporaryId);
            }
            if (values.thumbnail) {
                const temporaryId = yield uploadFilePromiseAndGetTemporaryId({
                    dispatch,
                    file: values.thumbnail,
                });
                _.set(values, 'thumbnailFileId', temporaryId);
            }
            return parseParams(Object.assign(Object.assign({}, values), { status }));
        });
        this.state = {
            isLoading: false,
            isPreviewLoading: false,
            isSaveLoading: false,
            isSubmitLoading: false,
        };
        this.unmount = false;
    }
    componentDidMount() {
        const { initializeSolution, loadProfessionalSolution, match: { params: { id }, }, } = this.props;
        // 前回作成時のデータが残っている可能性があるためクリア
        initializeSolution();
        // 一時保存からの再開の場合データをロード
        if (id) {
            loadProfessionalSolution(id);
        }
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { isFirstLoading, professionalSolution, solutionMiddleClasses } = this.props;
        const { isLoading, isPreviewLoading, isSaveLoading, isSubmitLoading } = this.state;
        const formInitialValue = initialValuesForFormSolutionAdd(professionalSolution, solutionMiddleClasses);
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main', showFooter: false }, { children: [_jsxs("div", Object.assign({ className: 'l-container load-container' }, { children: [isFirstLoading && _jsx(ProcessLoader, {}), _jsx("div", Object.assign({ className: 'l-container-9' }, { children: _jsx(StepMenu, { current: professionalSolution.step, max: 5 }) })), _jsx(FormSolutionCreate, { enableReinitialize: true, initialValues: formInitialValue, isLoading: isFirstLoading || isLoading, isSubmitLoading: isSubmitLoading, onSubmit: this.submitSolution })] })), _jsx("div", Object.assign({ className: 'l-bottom-wrap preview-wrap' }, { children: _jsx("div", Object.assign({ className: 'l-bottom-fix preview-box' }, { children: _jsxs("div", Object.assign({ className: 'footer-action' }, { children: [_jsx(SubmitButton, { className: 'link-text', isDisabled: isFirstLoading || isLoading, isLoading: isPreviewLoading, onClick: this.previewSolution, text: 'プレビュー' }), _jsx(SubmitButton, { buttonType: 'button', className: 'btn btn-secondary centered medium is-full', isDisabled: isFirstLoading || isLoading, isLoading: isSaveLoading, onClick: this.saveSolution, text: _jsxs(_Fragment, { children: [_jsx("i", Object.assign({ className: 'material-icons md-14' }, { children: "save_alt" })), "\u4FDD\u5B58\u3059\u308B"] }) })] })) })) }))] })));
    }
}
Add.propTypes = {
    dispatch: propFunc().isRequired,
    formFields: propShape().isRequired,
    history: propHistory(),
    initializeSolution: propFunc().isRequired,
    isFirstLoading: propBool().isRequired,
    loadProfessionalSolution: propFunc().isRequired,
    match: propMatch(),
    professionalSolution: propShape().isRequired,
    solutionMiddleClasses: propArrayShape().isRequired,
};
const mapStateToProps = ({ category, fetch, form, professionalSolution }) => {
    const isFirstLoading = isLoadingApis(fetch, API_GET_ONE_PROFESSIONAL_SOLUTION);
    return {
        formFields: form.FormSolutionCreate || {},
        isFirstLoading,
        professionalSolution,
        solutionMiddleClasses: category.solutionMiddleClass,
    };
};
const mapDispatchToProps = (dispatch) => ({
    dispatch,
    initializeSolution: () => {
        dispatch(initializeProfessionalSolution());
        dispatch(reset('FormSolutionCreate'));
    },
    loadProfessionalSolution: (id) => dispatch(apiGetOneProfessionalSolution(id, baseMeta)),
});
const enhance = compose(AuthenticationHoc({
    isPreProfessional: false,
    isProfessional: true,
}), connect(mapStateToProps, mapDispatchToProps));
export default enhance(Add);
